import _defineProperty from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import Loading from 'quasar/src/plugins/Loading.js';;
import { i18n } from '@/boot/i18n';
import Vue from 'vue'; // Wait the specified number of milliseconds

Vue.prototype.$wait = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ms) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return new Promise(function (resolve, reject) {
              return setTimeout(function () {
                return resolve();
              }, ms);
            });

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}(); // Safely wrap an async operation in a loader


Vue.prototype.$loading = function (func, loadingOptions) {
  return loadingFn(func, loadingOptions);
};

export function loadingFn(_x2) {
  return _loadingFn.apply(this, arguments);
}

function _loadingFn() {
  _loadingFn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(func) {
    var loadingOptions,
        _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            loadingOptions = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};

            if (!Loading.isActive) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt("return");

          case 3:
            _context2.prev = 3;
            Loading.show(_objectSpread({
              message: i18n.t('common.misc.loading')
            }, loadingOptions));
            _context2.next = 7;
            return func();

          case 7:
            return _context2.abrupt("return", _context2.sent);

          case 8:
            _context2.prev = 8;
            Loading.hide();
            return _context2.finish(8);

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[3,, 8, 11]]);
  }));
  return _loadingFn.apply(this, arguments);
}